<template>
    <div class="vue-google-map">
        <div id="map" style="width:100%;height:400px;"></div>
    </div>
</template>

<script>
    import GoogleMapsApiLoader from 'google-maps-api-loader'

    export default {
        props: ['addresses'],
        data: function() {
            return {
                google: null,
                map: null,
            };
        },
        async mounted() {
            const googleMapApi = await GoogleMapsApiLoader({
              apiKey: "AIzaSyCgBaRNhIQU8bs28xNyIr_txa4XpavZm84",
              libraries: ['geometry','places']
            })
            this.google = googleMapApi
            this.initializeMap()
        },
        computed: {
            //
        },
        methods: {
            initializeMap() {
                const mapOptions = {
                    center: {
                        lat: 0,
                        lng: 0
                    },
                    zoom: 4
                };

                const mapContainer = document.getElementById("map");

                this.map = new this.google.maps.Map(mapContainer, mapOptions);

                const service = new this.google.maps.places.PlacesService(this.map);
                service.getDetails({ placeId: 'ChIJY8FN9UFcXkYRAXvJOYDNSwM' }, (place, status) => {
                    if (status == this.google.maps.places.PlacesServiceStatus.OK) {
                        var marker = new this.google.maps.Marker({
                            map: this.map,
                            title: 'Köpsta 2, 725 98 Västerås',
                            position: place.geometry.location,
                            icon: {
                                path: google.maps.SymbolPath.CIRCLE,
                                fillColor: '#f00',
                                fillOpacity: 0.6,
                                strokeColor: '#000',
                                strokeOpacity: 0.9,
                                strokeWeight: 2,
                                scale: 10
                            }
                        });

                        marker.addListener("click", () => {
                          infoWindow.close();
                          infoWindow.setContent(marker.getTitle());
                          infoWindow.open(marker.getMap(), marker);
                        });

                        this.map.setCenter(marker.getPosition());
                        this.map.setZoom(8);
                    }
                });

                const geocoder = new this.google.maps.Geocoder();
                const infoWindow = new this.google.maps.InfoWindow();

                this.addresses.forEach((address) => {
                    geocoder.geocode({ address: address.address }, (results, status) => {
                        if (status !== 'OK') {
                            return;
                        }

                        var marker = new this.google.maps.Marker({
                            map: this.map,
                            title: address.label,
                            optimized: true,
                            position: results[0].geometry.location
                        });

                        marker.addListener("click", () => {
                          infoWindow.close();
                          infoWindow.setContent(marker.getTitle());
                          infoWindow.open(marker.getMap(), marker);
                        });
                    });
                });
            }
        }
    }
</script>
